import {
  any, boolean, date,
  nullable, number, object, string,
} from '@sda/sdk/helpers/types.bitmasks';

export const PrivateShowMask = {
  acceptsTerms: boolean,
  actualPromoSpend: number,
  allowEmailBlastsAfterShowEnds: boolean,
  allowEmailBlastsBeforeShowEnds: boolean,
  artistGuarantee: number,
  artistParkingInstructions: string,
  artistStripeAccountId: string | nullable,
  confirmedAt: date | nullable,
  createdAt: any,
  feedback: string,
  guestListExtra: number,
  hasBillet: boolean,
  hasGreenRoom: boolean,
  hasLocationOverride: boolean,
  hasOpener: boolean,
  hasPA: boolean,
  hasParking: boolean,
  hasSideDoorSupportFee: boolean,
  hasAcceptableStartDateOverride: boolean | nullable,
  isSoloShow: boolean,
  messageToPayee: string,
  notes: string,
  paymentTerms: string,
  privateAct: any,
  privateRequest: any,
  privateVenue: any,
  promoSpendRecouped: number,
  requestId: string | nullable,
  showPADescription: string,
  streamingUri: string,
  supportFeeAmount: number | nullable,
  supportFeeBaseAmount: number | nullable,
  supportFeeExchangeRate: number | nullable,
  supportFeeCheckoutId: string | nullable,
  supportFeeOverrideOwner: string | nullable,
  supportFeeOverrideReason: string | nullable,
  supportFeeOverrideAt: date | nullable,
  updatedAt: any,
  venueRepresentative: string,
  venueStripeAccountId: string | nullable,
  soundCheck: string | nullable,
  artistHyperwalletAccountId: string | nullable,
  venueHyperwalletAccountId: string | nullable,
  originalShowId: string | nullable,

  // Signatures
  oldSignatureData: any,
  signatureData: object,

  // ZOOM
  zoomMeetingId: string | nullable,
  zoomMeetingPassword: string | nullable,

  // MUX
  muxActiveAssetId: string | nullable,
  muxLiveStreamId: string | nullable,
  muxLiveStreamStatus: string | nullable,
  muxPlaybackId: string | nullable,
  muxRtmpsUrl: string | nullable,
  muxStreamEndedAt: date | nullable,
  muxStreamKey: string | nullable,
  videoAssetDownloadLink: string | nullable,
  videoAssetDownloadCreatedAt: date | nullable,
  videoRecordingLink: string | nullable,

  // Location
  civicAddress: string,
  compiledAddress: string,
  latLng: any,
  googlePlaceId: string,

  primaryContactName: string,
  primaryContactNumber: string,
  primaryContactRelationship: string,

  secondaryContactName: string,
  secondaryContactNumber: string,
  secondaryContactRelationship: string,

  // Profile updates
  privateProfiles: any,
};
